import React from 'react';
import {ConfigFieldDefinitionBase} from './config-field-definition-base';
import {NumericValueEditorComponent} from '../../../components/value-editors/numeric-value-editor/numeric-value-editor.component';

export class NumericFieldDefinition extends ConfigFieldDefinitionBase {
    constructor(title: string, description: string = '', private _allowDecimals: boolean = false) {
        super(title, description);
    }

    render(): React.ReactNode {
        return (<NumericValueEditorComponent key={this.configurationKey} fieldDefinition={this} allowDecimals={this._allowDecimals}/>);
    }
}